<template>
    <a-modal
        :visible="visible"
        :title="$t('qr_code_title')"
        @cancel="handleClose"
        :footer="null"
        width="400px"
        centered
    >
        <div class="qr-code-container">
            <qrcode-vue :value="serialNo" :size="200" level="H" />
            <p class="serial-no">{{ serialNo }}</p>
        </div>
    </a-modal>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

export default {
    name: 'QRCodeModal',
    components: {
        QrcodeVue
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        serialNo: {
            type: String,
            default: ''
        }
    },
    methods: {
        handleClose() {
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
.qr-code-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;

    .serial-no {
        margin-top: 15px;
        font-size: 16px;
        font-weight: bold;
    }
}
</style> 